import axios from "axios";

export const getHealthReport = async (store) =>
    await axios.get(`${process.env.REACT_APP_API}/inventory/health-all?store=${store}`);

export const getPriceReport = async (store) =>
    await axios.get(`${process.env.REACT_APP_API}/inventory/price-all?store=${store}`);

export const updatePrices = async (products, authtoken) =>
    await axios.post(`${process.env.REACT_APP_API}/inventory/update-prices`, products, {
        headers: {
            authtoken,
        },
    });

export const getReplenishInfo = async (store, product) =>
    await axios.get(`${process.env.REACT_APP_API}/inventory/replenish-all?store=${store}&product=${product}`);

export const getSupplierProductInfo = async (store, supplier) =>
    await axios.get(`${process.env.REACT_APP_API}/inventory/supplier-order?store=${store}&supplier=${supplier}`);

export const getBrandOrderInfo = async (store) =>
    await axios.get(`${process.env.REACT_APP_API}/inventory/brands-order?store=${store}`);
